import { render, staticRenderFns } from "./BoothAdvertisingTwo.vue?vue&type=template&id=a94211f4&scoped=true"
import script from "./BoothAdvertisingTwo.vue?vue&type=script&lang=js"
export * from "./BoothAdvertisingTwo.vue?vue&type=script&lang=js"
import style0 from "./BoothAdvertisingTwo.vue?vue&type=style&index=0&id=a94211f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94211f4",
  null
  
)

export default component.exports